angular.module('eficienciaFiscalModule')
    .factory('genericServiceHelper', ['httpService', 'pathService',
        function (httpService, pathService) {

            var defaults = {
                    url: '',
                    apiUrl: pathService.getApiUrl(),
                    screenId: '#base',
                    only: ['search', 'getList', 'get', 'save', 'update', 'delete'],
                    except: [],
                    callFunctionConfig: {
                        method: "GET",
                        holder: "q"
                    },
                    events: {
                        before: {},
                        after: {
                            'get': function (data) {
                                return data[0];
                            }
                        }
                    },
                    callFunctions: [],
                    idHolder: 'id',
                    functions: {
                        search: 'search',
                        getList: 'getList',
                        get: 'get',
                        save: 'save',
                        update: 'update',
                        delete: 'delete'
                    }
                },
                getSearchFn = function (configs, action) {
                    return function (params, callback, event, loadText, blockScreen, loadingTop) {
                        var url = getRoute(configs);
                        params = params || {};
                        url = pathService.parametrize(url, params);
                        return httpService.request({
                            url: url,
                            method: "GET",
                            blockScreen: blockScreen || true,
                            screenId: configs.screenId,
                            clickEvent: event,
                            loadingText: loadText,
                            loadingTop: loadingTop || false,
                            onSuccess: function (data) {
                                if (configs.events.after[action])
                                    data = configs.events.after[action](data);
                                if (callback)
                                    callback(data);
                            }
                        })
                    }
                },
                getRoute = function (configs, id) {
                    return configs.apiUrl + configs.url + (id || '')
                },
                getEnterServiceFn = function (configs) {
                    return function (method) {
                        return configs.service && !configs.service.hasOwnProperty(configs.functions[method]) && configs.only.contains(method) && !configs.except.contains(method)
                    }
                },
                getCallFunctionFn = function (configs) {
                    return function (_function, _blockScreen, _blockScreenExt, params) {
                        params = params || ['data', 'callback', 'event', 'loadText', 'blockScreen', 'blockScreenExt'];
                        var paramsObj = {};
                        params.each(function (value, index) {
                            paramsObj[value] = index
                        });
                        params = paramsObj;
                        return function () {
                            var args = arguments;
                            args[params['data']] = args[params['data']] || {};
                            args[params['data']][configs.callFunctionConfig.holder] = _function;
                            if (configs.callFunctionConfig.method == "GET")
                                return getSearchFn(configs)(args[params['data']], args[params['callback']], args[params['event']], args[params['loadText']]);
                            else
                                return httpService.request({
                                    url: getRoute(configs),
                                    method: configs.callFunctionConfig.method,
                                    data: args[params['data']],
                                    blockScreen: args[params['blockScreen']] != undefined ? args[params['blockScreen']] : (_blockScreen != undefined ? _blockScreen : true),
                                    blockScreenExt: args[params['blockScreenExt']] != undefined ? args[params['blockScreenExt']] : (_blockScreenExt != undefined ? _blockScreenExt : false),
                                    screenId: configs.screenId,
                                    clickEvent: args[params['event']],
                                    loadingText: args[params['loadText']],
                                    onSuccess: function (data) {
                                        if (args[params['callback']])
                                            args[params['callback']](data);
                                    }
                                })
                        }
                    }
                };

            return function (configuration) {
                var configs = cbk.extendDeep(['service'])({}, defaults, configuration),
                    enterService = getEnterServiceFn(configs),
                    getCallFunction = getCallFunctionFn(configs),
                    requestConfig = function (action, method, data, event, loadText, callback, blockScreen, id, loadingTop, blockScreenExt) {
                        if (configs.events.before[action])
                            data = configs.events.before[action](data);

                        return httpService.request({
                            url: getRoute(configs, id),
                            method: method,
                            data: data,
                            blockScreen: blockScreen == undefined ? true : blockScreen,
                            screenId: configs.screenId,
                            clickEvent: event,
                            blockScreenExt: blockScreenExt || false,
                            loadingText: loadText,
                            loadingTop: loadingTop || false,
                            onSuccess: function (data) {
                                if (configs.events.after[action])
                                    data = configs.events.after[action](data);

                                if (callback)
                                    callback(data);
                            }
                        });
                    },
                    addToService = function (functions) {
                        functions.each(function (_function) {
                            if (enterService(_function))
                                configs.service[configs.functions[_function]] = helper[_function];
                        })
                    },
                    helper = requestConfig;

                helper.search = getSearchFn(configs, 'search');

                helper.getList = function (callback, event, loadText) {
                    return getSearchFn(configs, 'getList')({}, callback, event, loadText);
                };

                helper.get = function (id, callback, event, loadText, blockScreen, loadingTop) {
                    return requestConfig('get', 'GET', undefined, event, loadText, callback, blockScreen, id, loadingTop);
                };

                helper.save = function (data, callback, event, loadText, blockScreen, loadingTop, blockScreenExt) {
                    return requestConfig('save', 'POST', data, event, loadText, callback, blockScreen, undefined, loadingTop, blockScreenExt)
                };

                helper.update = function (data, callback, event, loadText, blockScreen, loadingTop) {
                    return requestConfig('update', 'PUT', data, event, loadText, callback, blockScreen, data[configs.idHolder], loadingTop)
                };

                helper.delete = function (id, callback, event, loadText, blockScreen, loadingTop) {
                    return requestConfig('delete', 'DELETE', undefined, event, loadText, callback, blockScreen, id, loadingTop);
                };

                addToService(['search', 'getList', 'get', 'save', 'update', 'delete']);

                configs.callFunctions.each(function (_function) {
                    helper[_function.name] = configs.service[_function.name] = getCallFunction.apply(this, _function.args);
                });

                helper.route = getRoute(configs);
                return helper;
            }
        }
    ]);
